export const BATCH_SIZE_LIMIT = 50;

export function splitIntoChunks<T>(array: T[], chunkSize: number) {
  const chunks: T[][] = [];

  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }

  return chunks;
}
